"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModelFieldNestedListBuilderValue = exports.FormModelFieldNestedListBuilderGroup = exports.FormModelFieldNestedListBuilder = void 0;
/**
 * Constructs the entire NestedList options object to avoid individual sets which are expensive due to deep-cloning.
 *
 * This provides a wrapper around the internal nested list data, these helper classes will just have deep references inside the data.
 * Which also means they will generally not be == comparable, check the paths & value.
 */
class FormModelFieldNestedListBuilder {
    constructor(options) {
        if (options != null) {
            this.group = new FormModelFieldNestedListBuilderGroup(options);
        }
    }
    get options() {
        if (this.group != null) {
            return this.group.options;
        }
        return null;
    }
    createGroup(title) {
        if (this.group != null && this.group.options.title.length > 0) {
            if (title === this.group.options.title) {
                return this.group;
            }
            throw new Error(`Cannot rename group from "${this.group.options.title}" to "${title}"`);
        }
        this.group = new FormModelFieldNestedListBuilderGroup({ title, values: [] });
        return this.group;
    }
    getGroup(path) {
        let opts = this.group.options;
        for (const pathIndex of path) {
            if (opts == null || opts.values == null || pathIndex >= opts.values.length) {
                return null;
            }
            opts = opts.values[pathIndex].options;
        }
        if (opts == null || opts.values == null) {
            return null;
        }
        return new FormModelFieldNestedListBuilderGroup(opts);
    }
    getValue(path) {
        const group = this.getGroup(path.slice(0, path.length - 1));
        if (group == null) {
            return null;
        }
        return group.getValue(path[path.length - 1]);
    }
}
exports.FormModelFieldNestedListBuilder = FormModelFieldNestedListBuilder;
class FormModelFieldNestedListBuilderGroup {
    constructor(options) {
        if (options == null) {
            this.options = { title: '', values: [] };
        }
        else {
            this.options = options;
        }
    }
    get title() {
        return this.options.title;
    }
    get size() {
        return this.options.values.length;
    }
    setTitle(title) {
        this.options.title = title;
    }
    createValue(value, code, color, index) {
        const existingValue = this.options.values.find((v) => v.value === value);
        const existingColor = this.options.values.find((v) => v.color === color);
        if (existingValue && existingColor) {
            return new FormModelFieldNestedListBuilderValue(existingValue);
        }
        const newValue = { value, code, color };
        if (index != null) {
            this.options.values.splice(index, 0, newValue);
        }
        else {
            this.options.values.push(newValue);
        }
        return new FormModelFieldNestedListBuilderValue(newValue);
    }
    getValue(index) {
        if (index >= 0 && index < this.options.values.length) {
            return new FormModelFieldNestedListBuilderValue(this.options.values[index]);
        }
        return null;
    }
    findValue(str) {
        const index = this.options.values.findIndex((f) => f.value === str);
        return this.getValue(index);
    }
    deleteValue(index) {
        this.options.values.splice(index, 1);
    }
}
exports.FormModelFieldNestedListBuilderGroup = FormModelFieldNestedListBuilderGroup;
class FormModelFieldNestedListBuilderValue extends FormModelFieldNestedListBuilder {
    constructor(listValues) {
        super();
        this.listValues = listValues;
    }
    get value() {
        return this.listValues.value;
    }
    get color() {
        return this.listValues.color;
    }
    setValue(value) {
        this.listValues.value = value;
    }
    setColor(color) {
        this.listValues.color = color;
    }
    createGroup(title) {
        if (this.listValues.options != null && this.listValues.options.title === title) {
            return new FormModelFieldNestedListBuilderGroup(this.listValues.options);
        }
        const group = super.createGroup(title);
        this.listValues.options = group.options;
        return group;
    }
}
exports.FormModelFieldNestedListBuilderValue = FormModelFieldNestedListBuilderValue;
//# sourceMappingURL=form.nested.list.builder.js.map